/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-29 14:33:52
 */
import { NewsMixinService } from './service'
import { Infomation, Banner } from './model'

export class NewsMixinManager {
  series = []
  total: number
  menuId: string
  service: NewsMixinService
  image = ''
  newsList = []
  menuList = []
  informationReview = []
  page = 1
  per_page = 10000
  size = 10
  constructor (total: number, menuId: string, service: NewsMixinService) {
    this.total = total
    this.menuId = menuId
    this.service = service
    this.init()
  }

  init () {
    if (!this.menuId) {
      return
    }
    this.service.getInfomation(this.menuId, '').then((res: any) => {
      this.series = res
      this.newsList = this.series.slice(0, 3)
    })
  }

  informationReviewService () {
    this.service.informationReviewService().then((res: any) => {
      this.informationReview = res.filter((item: Banner) => {
        return !item.publish
      }).sort(function (prev: Banner, next: Banner) {
        return next.sort - prev.sort
      }).slice(0, 5)
    })
  }

  informationReviewServiceAll () {
    this.service.informationReviewService().then((res: any) => {
      this.informationReview = res.sort(function (prev: Banner, next: Banner) {
        return next.sort - prev.sort
      })
    })
  }

  async getNewstitles (id: string) {
    const params = {
      page: this.page,
      size: this.per_page
    }
    const res = await this.service.getNewsService(params)
    console.log(res)
    const result = res.filter((item: any) => {
      return item.pid === Number(id)
    })
    this.menuList = result.sort(function (prev: any, next: any) {
      return prev.sort - next.sort
    })
    console.log(this.menuList)
  }

  getInfomation (item: any) {
    this.service.getInfomation(item.id, '').then((res: any) => {
      item.infos = res.slice(0, 3)
    })
  }

  async getNewsInfomation (id: string) {
    const params = {
      page: this.page,
      size: this.size
    }
    await this.service.getInfomation(id, params).then((res: any) => {
      this.series = res
      console.log(this.series)
      this.series.map((item: any) => {
        this.total = item.total
      })
      this.image = this.series ? (this.series as any)[0].poster : ''
      this.newsList = this.series.slice(0, 2)
    })
  }

  showMoreHandler (menuTitle: string) {
    window.open(`/infoNews.html#/${this.menuId}/${menuTitle}`)
  }

  get asyncSeries () {
    console.log(this.series)
    return this.series.filter((item: any, key: number) => key < this.total)
  }

  get showMore () {
    return this.series.length > this.total
  }

  get shouldShowThisModule () {
    return this.series.length > 0
  }
}
